import querystring from 'query-string'

export const getNegotiatorapp = (
  location = globalThis.window !== undefined ? globalThis.window.location : null
) => {
  // Safe early return if location is null (SSR) or has no search string
  if (!location?.search) return
  const queryStringParameters = querystring.parse(location.search)
  return queryStringParameters?.['negotiatorapp']
}
